import React from 'react'

const LoginVerifyOTP = () => {
    return (
        <div>LoginVerifyOTP</div>
    )
}

export default LoginVerifyOTP